import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  assetDataService,
  assetSharedModelService,
  riskSharedModelService,
} from 'app/services';
import {
  actionIcon,
  confirmDialog,
  statusMeter,
  helpTooltip
} from 'app/components/global';
import editAssetTypeDialog from './dialog.editAssetTypeDialog';
// import syncAssetTypeConfirmDialog from './dialog.editAssetTypeDialog';
import copyAssetTypeDialog from './dialog.copyAssetTypeDialog';
import deleteAssetTypeConfirmDialog from './dialog.deleteAssetTypeConfirmDialog'
import controller from './asset-type.controller';
import directive from './asset-type.directive';


const assetTypeModule = angular.module('app.components.admin.assetAdmin.assetType', [
  actionIcon,
  confirmDialog,
  editAssetTypeDialog,
  // syncAssetTypeConfirmDialog,
  copyAssetTypeDialog,
  deleteAssetTypeConfirmDialog,
  loaderService,
  ssDialogService,
  assetDataService,
  assetSharedModelService,
  riskSharedModelService,
  statusMeter,
  helpTooltip,
])
  .directive('assetType', directive)
  .controller('AssetTypeController', controller);

export default assetTypeModule.name;

console.log('app.components.admin.assetAdmin.assetType created');
